"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentCount = exports.ContentCountValue = exports.Label = exports.ContentCountBlockContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _knotchWebReactComponents = require("@bit/knotchinc.web-react-components.loading");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", " {\n      display: inline-block;\n      margin-left: 7px;\n      margin-top: 0;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 24px;\n  font-size: 11px;\n  font-weight: bold;\n  display: inline-block;\n  transition: all .3s ease;\n  vertical-align: top;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  cursor: ", ";\n\n  &:first-child {\n    margin-left: 0;\n  }\n\n  ", " {\n    padding: 0;\n  }\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: white;\n  font-size: 12px;\n  margin-right: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  margin-bottom: 12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  transition: all .3s ease;\n  color: #616161;\n  white-space: nowrap;\n\n  @media(max-width: 920px) {\n    padding-right: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentCountBlockContainer = _styledComponents["default"].div(_templateObject());

exports.ContentCountBlockContainer = ContentCountBlockContainer;

var Label = _styledComponents["default"].div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette[7];
});

exports.Label = Label;

var ContentCountValue = _styledComponents["default"].div(_templateObject3());

exports.ContentCountValue = ContentCountValue;

var ContentCount = _styledComponents["default"].div(_templateObject4(), function (_ref2) {
  var hasAction = _ref2.hasAction;
  return hasAction ? 'pointer' : 'default';
}, _knotchWebReactComponents.SpinContainer, function (_ref3) {
  var inline = _ref3.inline;
  return inline && (0, _styledComponents.css)(_templateObject5(), ContentCountValue);
});

exports.ContentCount = ContentCount;

//# sourceMappingURL=styled.js.map